import classNames from 'classnames';
import Img, { Props as ImgProps } from '../../Atoms/Image';

interface Props {
  images: [
    ImgProps,
    ImgProps,
    ImgProps,
    ImgProps,
    ImgProps
  ];
  className?: string;
}

interface SmallProps {
  images: [ImgProps, ImgProps, ImgProps];
  className?: string;
}

function MeshMosaic({ images, className }: Props) {
  return (
    <div
      className={classNames([
        'grid grid-cols-5 gap-3 md:gap-5 lg:gap-7',
        className
      ])}
    >
      {images.map((image) => (
        <Img
          key={images.indexOf(image)}
          {...image}
          className={classNames([
            'w-full rounded-xl',
            images.indexOf(image) === 0 &&
              'col-span-3 row-span-6 row-start-2',
            images.indexOf(image) === 1 &&
              'col-span-3 row-span-6',
            images.indexOf(image) === 2 &&
              'col-span-2 col-start-4 row-span-4 row-start-1',
            images.indexOf(image) === 3 &&
              'col-span-2 row-span-4 row-start-5',
            images.indexOf(image) === 4 &&
              'col-span-2 col-start-4 row-span-4 row-start-[9]',
            image.className
          ])}
        />
      ))}
    </div>
  );
}

export function MeshMosaicSmall({
  images,
  className
}: SmallProps) {
  return (
    <div
      className={classNames([
        'relative mr-auto -ml-14 flex w-10/12 flex-col items-center md:mt-80 md:ml-0 md:w-8/12 md:gap-7 lg:mt-0 lg:w-10/12 lg:translate-y-1/4 2xl:w-full',
        className
      ])}
    >
      {images.map((image) => (
        <Img
          key={images.indexOf(image)}
          {...image}
          className={classNames([
            'rounded-xl lg:w-full',
            images.indexOf(image) === 0 &&
              'bottom-full right-0 ml-auto mb-3 max-w-[80%] md:absolute md:mb-7 md:max-w-[65%]',
            images.indexOf(image) === 1 && 'w-full md:ml-0',
            images.indexOf(image) === 2 &&
              'absolute left-full bottom-0 top-0 my-auto ml-3 max-w-[92%] md:bottom-auto md:ml-7 md:max-w-[82%]' +
                ' md:-translate-y-1/2'
          ])}
        />
      ))}
    </div>
  );
}

export default MeshMosaic;
